import {
  Snackbar,
  Alert,
  // Grid,
  Card,
  Icon,
  CircularProgress,
  Backdrop,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
  Box,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Grid,
  ListItem,
  ListItemText,
} from "@mui/material";

import { useEffect, useRef, useState, useCallback } from "react";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
import MDInput from "theme/components/MDInput";
// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useGeolocated } from "react-geolocated";
import axios from "axios.js";
import usePageTitle from "app/pageTitle";
import Webcam from "react-webcam";
import * as faceapi from "face-api.js";
// import AppConfig from "appConfig";
import PushNotificationMgr from "app/components/push_notification_mgr";

function AttendancesPage() {
  const pageTitle = `Attendance`;
  usePageTitle(pageTitle);

  const [attendances, setAttendances] = useState([]);
  const [locations, setLocations] = useState([]);
  const [customFields, setCustomFields] = useState([]);

  const [selectedAttendance, setSelectedAttendance] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [entryType, setEntryType] = useState(null);
  const [customFieldValues, setCustomFieldValues] = useState({});

  const [pageLoaded, setPageLoaded] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [
    allowPushNotificationDialogState,
    setAllowPushNotificationDialogState,
  ] = useState(false);
  const [openImageCaptureDialog, setOpenImageCaptureDialog] = useState(false);

  const [imageCapture, setImageCapture] = useState(null);
  const [validatingFace, setValidatingFace] = useState(false);

  const [statusMsg, setStatusMsg] = useState("");
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [openErrorDialog, setOpenErrorDialog] = useState(false);

  useEffect(() => {
    if (selectedAttendance === null) {
      return;
    }

    setEntryType(null);
    setSelectedLocation(null);
    setCustomFieldValues({});

    setLocations([]);
    setCustomFields([]);

    attendances.every((atd) => {
      if (atd.reference === selectedAttendance) {
        setLocations(atd.locations);
        if (atd.custom_fields !== null) {
          setCustomFields(atd.custom_fields);
        }
        return false;
      }
      return true;
    });
  }, [selectedAttendance]);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`agents/attendances/init.json`)
        .then((result) => {
          setShowLoading(false);
          // console.log(result.data.data);
          if (result.data.status === "success") {
            setAttendances(result.data.data.attendances);
            setPageLoaded(true);
          } else {
            setErrMsg(result.data.data.message);
            setSeverity("error");
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setSeverity("error");
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
      positionOptions: {
        enableHighAccuracy: true,
      },
      userDecisionTimeout: 5000,
    });

  function getGPSCoords() {
    if (!isGeolocationAvailable) {
      return false;
    }

    if (!isGeolocationEnabled) {
      return false;
    }

    if (coords) {
      return { latitude: coords.latitude, longitude: coords.longitude };
    }

    return false;
  }

  async function checkIn() {
    if (selectedLocation === null) {
      setSeverity("error");
      setErrMsg("Please select a campaign location.");
      setOpen(true);
      return;
    }

    const gpsCoords = getGPSCoords();
    // console.log(gpsCoords);
    if (!gpsCoords) {
      setSeverity("error");
      setErrMsg("Please enable and allow browser's location and GPS access.");
      setOpen(true);
      return;
    }

    if (imageCapture === null) {
      setSeverity("error");
      setErrMsg("Your selfie is required");
      setOpen(true);
      return;
    }

    setOpenImageCaptureDialog(false);
    setShowLoading(true);
    const json = {
      reference: selectedAttendance,
      location: selectedLocation,
      entry_type: entryType,
      face: imageCapture,
      latitude: gpsCoords.latitude,
      longitude: gpsCoords.longitude,
      custom_fields: customFieldValues,
    };

    // console.log(json);

    await axios
      .post("agents/attendances/checkin.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          //   setSeverity("success");
          //   setErrMsg(result.data.data.message);
          //   setOpen(true);
          setStatusMsg(result.data.data.message);
          setOpenSuccessDialog(true);
        } else {
          //   setSeverity("error");
          //   setErrMsg(result.data.data.message);
          //   setOpen(true);
          setStatusMsg(result.data.data.message);
          setOpenErrorDialog(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine
              ? ""
              : "Make sure you have an active internet connection"
          }`,
        );
        setOpen(true);
      });
  }

  const rnd = (Math.random() + 1).toString(36).substring(9);
  const webcamRef = useRef(rnd); // create a webcam reference

  const [cameraUsed, setCameraUsed] = useState(false);
  const videoConstraints = {
    facingMode: cameraUsed ? "user" : { exact: "environment" },
  };

  async function validateFace(bas64ImageData) {
    await faceapi.loadTinyFaceDetectorModel("/face_models");
    const base64Response = await fetch(bas64ImageData);
    const blob = await base64Response.blob();
    const image = await faceapi.bufferToImage(blob);

    const detection = await faceapi.detectSingleFace(
      image,
      new faceapi.TinyFaceDetectorOptions(),
    );
    if (!detection) {
      setSeverity("error");
      setErrMsg("Unable to detect your face.");
      setOpen(true);
      return false;
    }

    return true;
  }

  // create a capture function
  const capture = useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (!imageSrc) {
      setSeverity("error");
      setErrMsg("No photo image found.");
      setOpen(true);
      setValidatingFace(false);
      return;
    }

    setValidatingFace(true);
    const passed = await validateFace(imageSrc);
    setValidatingFace(false);
    if (passed) {
      setImageCapture(imageSrc);
    }
  }, [webcamRef]);

  useEffect(() => {
    if (imageCapture === null) {
      return;
    }

    checkIn();
  }, [imageCapture]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PushNotificationMgr
        displayState={allowPushNotificationDialogState}
        setDisplayState={setAllowPushNotificationDialogState}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openImageCaptureDialog}>
        <DialogTitle>
          <MDBox>Selfie</MDBox>
          <MDTypography variant="caption" fontWeight="light">
            Take a selfie
          </MDTypography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <MDBox>
              <Webcam
                // height={"100%"}
                width="100%"
                ref={webcamRef}
                screenshotQuality={1}
                videoConstraints={videoConstraints}
              />
            </MDBox>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenImageCaptureDialog(false);
            }}
            color="dark"
            iconOnly
            circular
            variant="outlined"
          >
            <Icon>close</Icon>
          </MDButton>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <MDButton
            onClick={() => {
              setCameraUsed(!cameraUsed);
            }}
            color="warning"
            iconOnly
            circular
            variant="outlined"
          >
            <Icon>cameraswitch</Icon>
          </MDButton>
          &nbsp;
          <Box>
            {validatingFace === false ? (
              <MDButton
                color="info"
                variant="outlined"
                iconOnly
                circular
                onClick={() => {
                  // setValidatingFace(true);
                  capture();
                }}
              >
                <Icon>photo_camera</Icon>
              </MDButton>
            ) : (
              <MDBox>
                &nbsp;
                <CircularProgress />
              </MDBox>
            )}
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog open={openSuccessDialog} fullWidth maxWidth="xs">
        <DialogContent>
          <MDBox mt={3} align="center" mb={3}>
            <MDBox>
              <Box mt={1}>
                <Box sx={{ position: "relative", display: "inline-flex" }}>
                  <CircularProgress
                    variant="determinate"
                    size={120}
                    thickness={2}
                    color="success"
                    value={100}
                  />
                  <Box
                    sx={{
                      top: 0,
                      left: 0,
                      bottom: 0,
                      right: 0,
                      position: "absolute",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon color="success" fontSize="large">
                      check
                    </Icon>
                  </Box>
                </Box>
              </Box>
            </MDBox>
            <MDBox mt={2}>
              <MDTypography variant="h6" fontWeight="light">
                {statusMsg}
              </MDTypography>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenSuccessDialog(false);
            }}
            color="dark"
            iconOnly
            circular
            variant="outlined"
          >
            <Icon>close</Icon>
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openErrorDialog} fullWidth maxWidth="xs">
        <DialogContent>
          <MDBox mt={3} align="center" mb={3}>
            <MDBox>
              <Box mt={1}>
                <Box sx={{ position: "relative", display: "inline-flex" }}>
                  <CircularProgress
                    variant="determinate"
                    size={120}
                    thickness={2}
                    color="error"
                    value={100}
                  />
                  <Box
                    sx={{
                      top: 0,
                      left: 0,
                      bottom: 0,
                      right: 0,
                      position: "absolute",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon color="error" fontSize="large">
                      close
                    </Icon>
                  </Box>
                </Box>
              </Box>
            </MDBox>
            <MDBox mt={2}>
              <MDTypography variant="h6" fontWeight="light">
                {statusMsg}
              </MDTypography>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenErrorDialog(false);
            }}
            color="dark"
            iconOnly
            circular
            variant="outlined"
          >
            <Icon>close</Icon>
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox mb={3}>
        <Grid
          container
          spacing={3}
          display="flex"
          alignItems="center"
          justifyContent="space-evenly"
        >
          <Grid item xs={12} md={7} lg={7}>
            <MDBox mt={5}>
              <Card>
                <MDBox p={2}>
                  <MDBox mb={3} display="flex" justifyContent="space-between">
                    <MDBox>
                      <MDTypography variant="h6" fontWeight="medium">
                        Mark Attendance
                      </MDTypography>
                    </MDBox>
                    <MDBox>
                      <Icon>assignment_ind</Icon>
                    </MDBox>
                  </MDBox>
                  {attendances.length > 0 ? (
                    <MDBox mt={1}>
                      <MDBox>
                        <FormControl sx={{ minWidth: 120, width: "100%" }}>
                          <InputLabel>Select Attendance</InputLabel>
                          <Select
                            value={selectedAttendance}
                            label="Select Attendance"
                            sx={{ padding: "12px", paddingLeft: "3px" }}
                            onChange={(e) =>
                              setSelectedAttendance(e.target.value)
                            }
                          >
                            {attendances.map((attendance) => (
                              <MenuItem value={attendance.reference}>
                                <ListItem>
                                  <ListItemText
                                    primary={
                                      <MDTypography
                                        variant="h6"
                                        fontWeight="regular"
                                      >
                                        {attendance.title}
                                      </MDTypography>
                                    }
                                    secondary={
                                      <MDTypography
                                        variant="body2"
                                        fontSize={14}
                                      >
                                        {attendance.account}
                                      </MDTypography>
                                    }
                                  />
                                </ListItem>
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </MDBox>
                      {selectedAttendance && (
                        <MDBox>
                          <MDBox mt={5}>
                            <FormControl sx={{ minWidth: 120, width: "100%" }}>
                              <InputLabel>Select Action</InputLabel>
                              <Select
                                label="Select Action"
                                sx={{ padding: "12px", paddingLeft: "3px" }}
                                onChange={(e) => setEntryType(e.target.value)}
                              >
                                <MenuItem value="CHECK_IN">CHECK-IN</MenuItem>
                                {selectedAttendance.check_out_time !== null && (
                                  <MenuItem value="CHECK_OUT">
                                    CHECK-OUT
                                  </MenuItem>
                                )}
                              </Select>
                            </FormControl>
                          </MDBox>

                          <MDBox mt={5}>
                            <FormControl sx={{ minWidth: 120, width: "100%" }}>
                              <InputLabel>Select Location</InputLabel>
                              <Select
                                label="Select Location"
                                sx={{ padding: "12px", paddingLeft: "3px" }}
                                onChange={(e) =>
                                  setSelectedLocation(e.target.value)
                                }
                              >
                                {locations.map((loc) => (
                                  <MenuItem value={loc.reference}>
                                    {loc.title}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </MDBox>

                          {customFields !== null && customFields.length > 0 && (
                            <MDBox>
                              {customFields.map((fld) => (
                                <MDBox mt={5}>
                                  {fld.options ? (
                                    <FormControl
                                      sx={{ minWidth: 120, width: "100%" }}
                                    >
                                      <InputLabel>{fld.title}</InputLabel>
                                      <Select
                                        label={fld.title}
                                        sx={{
                                          padding: "12px",
                                          paddingLeft: "3px",
                                        }}
                                        onChange={(e) => {
                                          const tmp = customFieldValues;
                                          tmp[fld.reference] = e.target.value;
                                          setCustomFieldValues(tmp);
                                        }}
                                      >
                                        {fld.options.map((opt) => (
                                          <MenuItem value={opt}>{opt}</MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  ) : (
                                    <MDInput
                                      name={fld.reference}
                                      margin="dense"
                                      label={fld.title}
                                      type="text"
                                      fullWidth
                                      variant="outlined"
                                      onChange={(e) => {
                                        const tmp = customFieldValues;
                                        tmp[fld.reference] = e.target.value;
                                        setCustomFieldValues(tmp);
                                      }}
                                    />
                                  )}
                                </MDBox>
                              ))}
                            </MDBox>
                          )}
                        </MDBox>
                      )}

                      <MDBox mt={10}>
                        <MDButton
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            if (selectedAttendance === null) {
                              setSeverity("error");
                              setErrMsg("Select an attendance.");
                              setOpen(true);
                              return;
                            }

                            if (selectedLocation === null) {
                              setSeverity("error");
                              setErrMsg("Select a location.");
                              setOpen(true);
                              return;
                            }

                            if (entryType === null) {
                              setSeverity("error");
                              setErrMsg("Select a action.");
                              setOpen(true);
                              return;
                            }

                            if (customFields.length > 0) {
                              const passed = customFields.every((f) => {
                                if (
                                  !Object.keys(customFieldValues).includes(
                                    f.reference,
                                  )
                                ) {
                                  setSeverity("error");
                                  setErrMsg(`${f.title} is required`);
                                  setOpen(true);
                                  return false;
                                }

                                return true;
                              });

                              if (!passed) {
                                return;
                              }
                            }

                            setOpenImageCaptureDialog(true);
                            setValidatingFace(false);
                          }}
                          sx={{ width: "100%" }}
                        >
                          Mark Attendance
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  ) : (
                    <MDBox>
                      {pageLoaded && (
                        <MDTypography variant="subtitle2">
                          No records available.
                        </MDTypography>
                      )}
                    </MDBox>
                  )}
                </MDBox>
              </Card>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AttendancesPage;
